import { ReactNode, FC, CSSProperties } from "react";
import { Dialog, DialogActions, DialogTitle, IconButton } from "@mui/material";

import { useTranslation } from "react-i18next";
import { CloseIcon } from "../../assets/images/svg";
import { SimpleButton, SimpleText } from "..";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store.ts";

type SimpleDialogProps = {
  open: boolean;
  handleClose?: () => void;
  handleConfirm?: () => void;
  handleCancel?: () => void;
  title?: string;
  children: ReactNode;
  loading?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  style?: CSSProperties;
};

const SimpleDialog: FC<SimpleDialogProps> = ({
  open,
  handleClose,
  handleConfirm,
  handleCancel,
  title,
  children,
  loading,
  confirmLabel = "Spremi",
  cancelLabel = "Cancel",
}) => {
  const { contrast } = useSelector(
    (state: RootState) => state?.settings?.data?.disability,
  );
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={undefined}
      disableEscapeKeyDown
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "16px",
          //paddingTop: 5,
          paddingBottom: "15px",
          position: "relative",
          overflowX: "hidden",
        },
      }}
    >
      {handleClose && (
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#000",
            "&:focus": {
              outline: "none",
              boxShadow: "none",
            },
          }}
        >
          <CloseIcon color={contrast ? "#000" : "#001E96"} />
        </IconButton>
      )}

      {title && (
        <DialogTitle>
          <SimpleText value={title} type="dialogTitle" />
        </DialogTitle>
      )}

      <div style={{ marginLeft: 20, marginRight: 20 }}>{children}</div>

      <DialogActions
        style={{ marginTop: 40 }}
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column-reverse",
            sm: "row",
            lg: "row",
          },
        }}
      >
        {handleCancel && (
          <SimpleButton
            buttonLabel={t(cancelLabel)}
            onClick={handleCancel}
            sx={{
              minWidth: {
                xs: "75vw",
                sm: "150px",
                lg: "150px",
              },
              marginRight: {
                xs: "5px",
                sm: "15px",
                lg: "15px",
              },
            }}
            type="redButton"
            loading={loading}
          />
        )}
        {handleClose && (
          <SimpleButton
            buttonLabel="Close"
            onClick={handleClose}
            sx={{
              minWidth: {
                xs: "75vw",
                sm: "150px",
                lg: "150px",
              },
              marginTop: {
                xs: "15px",
                sm: "0px",
                lg: "0px",
              },
            }}
            type="mainButton"
            variant="outlined"
          />
        )}
        {handleConfirm && (
          <SimpleButton
            buttonLabel={t(confirmLabel)}
            onClick={handleConfirm}
            sx={{
              minWidth: {
                xs: "75vw",
                sm: "150px",
                lg: "150px",
              },
              marginRight: {
                xs: "5px",
                sm: "15px",
                lg: "15px",
              },
            }}
            type="mainButton"
            loading={loading}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default SimpleDialog;
